// GuestTopBar.js
import React from 'react';
import {
  View,
  Text,
  Image,
  StyleSheet,
  Platform,
  Dimensions,
  TouchableOpacity,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import topImage from '../../assets/judgeCourtBanner.png';
import topIcon from '../../assets/jc.png';

const windowWidth = Dimensions.get('window').width;

const GuestTopBar = ({children, isScrolled = false}) => {
  return (
    <View style={[styles.topBar, isScrolled && styles.topBarScrolled]}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
        }}
      >
        {/* বাম পাশে লোগো */}
        {/* <View style={styles.leftSection}>
          <View style={styles.logoShadow}>
            <Image style={styles.logo} source={topIcon} />
          </View>
        </View> */}

        {/* মাঝের অংশ - টাইটেল ও ব্যানার */}
        <View style={styles.centerSection}>
          <View style={{flexDirection: 'row'}}>
            <Image
              style={{
                width: 225,
                height: 27,
                marginTop: 3,
                justifyContent: 'center',
                alignSelf: 'center',
              }}
              source={topImage}
            />
          </View>
          <Text style={styles.textS}>
            (For Judge Court Diary & Case Search)
          </Text>
          <Text style={styles.textSP}>Powered By: Siddique Enterprise</Text>
        </View>

        {/* ডান পাশে নোটিফিকেশন */}
        <View style={styles.rightSection}>
          <TouchableOpacity
            style={styles.notificationButton}
            activeOpacity={0.7}
          >
            <Icon name="notifications" size={22} color="#FFD700" />
            <View style={styles.notificationBadge}>
              <Text style={styles.badgeText}>3</Text>
            </View>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  topBar: {
    width: '100%',
    height: 78,
    flexDirection: 'row',
    backgroundColor: '#0373BB',
    paddingTop: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  topBarScrolled: {
    backgroundColor: '#0373BB',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 3},
    shadowOpacity: 0.15,
    shadowRadius: 5,
    elevation: 6,
  },
  leftSection: {
    width: 70,
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 8,
  },
  logo: {
    width: 58,
    height: 58,
    borderRadius: 44,
  },
  logoShadow: {
    width: 58,
    height: 58,
    borderRadius: 40,
    shadowColor: '#fff',
    shadowOpacity: 0.3,
    shadowRadius: 15,
    shadowOffset: {
      height: 2,
      width: 0,
    },
    elevation: 8,
  },
  centerSection: {
    flex: 6,
    padding: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 7,
    marginHorizontal: 16,
  },
  rightSection: {
    width: 60,
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: 8,
  },
  notificationButton: {
    padding: 6,
    position: 'relative',
  },
  notificationBadge: {
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: '#FF4444',
    borderRadius: 10,
    width: 18,
    height: 18,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1.5,
    borderColor: '#0373BB',
  },
  badgeText: {
    color: '#fff',
    fontSize: 10,
    fontWeight: 'bold',
  },
  textS: {
    fontSize: 14,
    color: '#ff0',
    marginLeft: 5,
    fontFamily: Platform.OS === 'web' ? 'Aachen-BT' : 'normal',
    lineHeight: 19,
    textAlign: 'center',
    justifyContent: 'center',
  },
  textSP: {
    fontSize: 18,
    color: '#ff0',
    marginLeft: 13,
    fontFamily: Platform.OS === 'web' ? 'Aachen-BT' : 'normal',
    lineHeight: 20,
    textAlign: 'center',
    justifyContent: 'center',
  },
});

export default GuestTopBar;
